module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-144x144.2e96c4abe1ea4145e334c292543df4e7.png";